import {useEffect} from 'react';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import {Link} from 'react-router-dom';

const DatosCorrectos = ({ envioActivado, respuesta }) => {
  const MySwal = withReactContent(Swal);

  useEffect(() => {
    if (envioActivado) {
      showAlert();
    }
  }, [envioActivado]);

  const showAlert = () => {
    let timerInterval;

    // Mostrar un mensaje de carga mientras se procesan los datos
    MySwal.fire({
      title: "Espere mientras se envían sus datos!",
      timer: 2000,
      timerProgressBar: true,
      didOpen: () => {
        Swal.showLoading();
      },
      willClose: () => {
        clearInterval(timerInterval);
      }
    }).then((result) => {
      // Dependiendo de la respuesta, mostrar un mensaje de éxito o de error
      if (result.dismiss === Swal.DismissReason.timer) {
        const Toast = Swal.mixin({
          toast: true,
          position: 'center',
          showConfirmButton: false,
          timer: 4000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer);
            toast.addEventListener('mouseleave', Swal.resumeTimer);
          }
        });

        console.log("respuesta",respuesta);
        if (respuesta == true) {
          
          Toast.fire({
            icon: 'success',
            title: 'Te has inscrito en el curso con exito'
          });
          window.history.back();
        } else {
          
          Toast.fire({
            icon: 'error',
            title: 'Error al enviar el correo. Por favor intente de nuevo.'
          });
        }
      }
    });
  };

  return null;
};



const PlazasAgotadas = ({ envioActivado }) => {
  useEffect(() => {
    if (envioActivado) {
      showAlert();
    }
  }, [envioActivado]);

  const showAlert = () => {
    Swal.fire({
      title: 'Plazas del curso agotadas',
      text: "Este curso ya está completo, pero puedes incribirte en la lista de espera si lo deseas.",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Inscribirme en la lista ',
      cancelButtonText: 'Volver a los cursos',
    }).then((result) => {
      if (result.isConfirmed) {
        envioActivado=false
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        <Link to={window.history.back()} />
      }
    });
  };

  return null;
};

const ServerErrorEnvioForm = ({ envioActivado, mensajeError }) => {
  // console.log("envioActivado ",envioActivado);
  
  useEffect(() => {
    if (envioActivado==false) {
      console.log("HOLA ERROR");
      showAlert();
    }
  }, [envioActivado]);

  const showAlert = () => {
    Swal.fire({
        icon: "error",
        title: "Error al enviar",
        text: mensajeError,
        
      
    }).then((result) => {
      if (result.isConfirmed) {
        envioActivado=false
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        <Link to={window.history.back()} />
      }
    });
  };

  return null;
};

const DatosIncorrectos = ({ envioActivado }) => {
  useEffect(() => {
    if (envioActivado==false) {
      showAlert();
    }
  }, [envioActivado]);

  const showAlert = () => {
    Swal.fire({
      icon: "warning",
        title: "Error de Petición",
        text: "Ha habido un error en la petición. Intentelo más tarde",
        
      
    }).then((result) => {
      if (result.isConfirmed) {
        envioActivado=false
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        <Link to={window.history.back()} />
      }
    });
  };

  return null;
};

export {DatosCorrectos , PlazasAgotadas, ServerErrorEnvioForm,DatosIncorrectos};